"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ApolloErrorMessage_1 = require("@components/ApolloErrorMessage");
var Button_1 = __importDefault(require("@components/Button"));
var Loading_1 = __importDefault(require("@components/Loading"));
var Pagination_1 = __importDefault(require("@components/Pagination"));
var Table_1 = require("@features/ItemLogPage/components/OverallList/Table");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_use_1 = require("react-use");
var RulesAndHistoryModal_1 = __importStar(require("src/react-app/features/ItemCommon/components/RulesAndHistoryModal"));
var checkIsQueryEmpty = function () {
    var url = new URL(window.location.href);
    var urlSearchParams = new URLSearchParams(url.search);
    var queryParams = ['id', 'from', 'to', 'status', 'type', 'filterId'];
    return !queryParams.find(function (queryParam) { return urlSearchParams.get(queryParam); });
};
function NoResults(_a) {
    var noResultMsg = _a.noResultMsg, resetSearch = _a.resetSearch;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { className: "lead has-no-results" },
        react_1.default.createElement("h2", null, noResultMsg),
        react_1.default.createElement("a", { className: "link", onClick: resetSearch }, t('itemLog:TABLE.TEXT.RESET_SEARCH'))));
}
function NoData(_a) {
    var angularJsDependencies = _a.angularJsDependencies, domain = _a.domain, noItemsImported = _a.noItemsImported, noData = _a.noData;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { className: "lead has-no-data", "data-ng-transclude": "noData" }, !angularJsDependencies.userPermissionManager.hasPermissionToEnterRoute('app.assignment.csvImporter.step0', domain) ? (react_1.default.createElement("div", null,
        react_1.default.createElement("h2", null, noItemsImported))) : (react_1.default.createElement("div", null,
        react_1.default.createElement("h2", null, noData),
        react_1.default.createElement("a", { target: "_blank", "data-ui-sref": "app.assignment.csvImporter.step0", onClick: function () {
                var url = angularJsDependencies.href('app.assignment.csvImporter.step0');
                window.open(url, '_blank');
            } },
            react_1.default.createElement(Button_1.default, { text: t('itemLog:TABLE.BUTTON.IMPORT_SAMPLE') })),
        react_1.default.createElement("p", { className: "eva-items-integrate-text" },
            t('itemLog:TABLE.TEXT.INTEGRATE'),
            "\u00A0",
            react_1.default.createElement("a", { className: "eva-link-primary", href: "http://besedo.com/api-documentation/" }, t('itemLog:TABLE.LINK.API')))))));
}
function OverallList(_a) {
    var resetSearch = _a.resetSearch, paginate = _a.paginate, angularJsDependencies = _a.angularJsDependencies, domain = _a.domain, 
    // Table props
    order = _a.order, onSortOrderChange = _a.onSortOrderChange, displayQueue = _a.displayQueue, minDate = _a.minDate, transformedData = _a.transformedData, isLoading = _a.isLoading, searchError = _a.searchError;
    var _b = __read((0, react_1.useState)(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var _c = __read(react_1.default.useState(RulesAndHistoryModal_1.TAB_MATCHED_RULES), 2), selectedTab = _c[0], setSelectedTab = _c[1];
    var _d = __read((0, react_1.useState)(null), 2), selectedJob = _d[0], setSelectedJob = _d[1];
    var _e = __read((0, react_1.useState)(true), 2), showLoader = _e[0], setShowLoader = _e[1];
    var isQueryEmpty = checkIsQueryEmpty();
    // Debounce on loader to avoid flickering
    (0, react_use_1.useDebounce)(function () {
        setShowLoader(isLoading);
    }, 300, [isLoading]);
    var hasNoData = !isLoading && !searchError && transformedData.total === 0 && isQueryEmpty;
    var hasNoResults = !showLoader && !searchError && transformedData.total === 0 && !isQueryEmpty;
    var t = (0, react_i18next_1.useTranslation)(['itemLog']).t;
    var msg = {
        noData: t('itemLog:TABLE.TEXT.NO_DATA'),
        noResult: t('itemLog:TABLE.TEXT.NO_RESULT'),
        noItemsImported: t('itemLog:TABLE.TEXT.NO_ITEMS_IMPORTED'),
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "empty-ng-table" },
            hasNoData && (react_1.default.createElement(NoData, { angularJsDependencies: angularJsDependencies, domain: domain, noData: msg.noData, noItemsImported: msg.noItemsImported })),
            hasNoResults && react_1.default.createElement(NoResults, { noResultMsg: msg.noResult, resetSearch: resetSearch }),
            react_1.default.createElement(ApolloErrorMessage_1.ApolloErrorMessage, { error: searchError, title: t('itemLog:TABLE.TEXT.HAS_ERROR'), refetchData: resetSearch, tryAgainText: t('itemLog:TABLE.BUTTON.TRY_AGAIN') }),
            showLoader && react_1.default.createElement(Loading_1.default, null),
            !searchError && (react_1.default.createElement("div", { className: "eva-list-has-data ".concat(isLoading ? 'eva-list-is-loading' : '') },
                react_1.default.createElement(Table_1.Table, { order: order, onSortOrderChange: onSortOrderChange, displayQueue: displayQueue, items: transformedData === null || transformedData === void 0 ? void 0 : transformedData.items, openRulesAndHistoryModal: function (item) {
                        // when we open the modal from the rule we should always show the MATCHED_RULES tab
                        setSelectedTab(RulesAndHistoryModal_1.TAB_MATCHED_RULES);
                        setIsOpen(true);
                        setSelectedJob(item);
                    }, angularJsDependencies: angularJsDependencies }),
                react_1.default.createElement(Pagination_1.default, { paginate: paginate, loading: isLoading, currentPage: transformedData.currentPage, isNextDisabled: transformedData.isNextDisabled, isPreviousDisabled: transformedData.isPreviousDisabled })))),
        react_1.default.createElement(RulesAndHistoryModal_1.default, { selectedTab: selectedTab, setSelectedTab: setSelectedTab, selectedJob: selectedJob, isOpen: isOpen, setIsOpen: setIsOpen, angularJsDependencies: angularJsDependencies, minDate: minDate })));
}
exports.default = OverallList;
